

import { createContext } from 'react';

import type { ButtonRootContextInterface } from '../types/button-root.types';

export const ButtonRootContext = createContext<ButtonRootContextInterface>({});

ButtonRootContext.displayName = 'Button.Root.Context';
